<template>
  <div class="d-inline-block">
    <v-menu
      v-model="showMenu"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-y
      @mouseenter="showMenu = true"
      @mouseleave="showMenu = false"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            @click="showMenu = !showMenu"
            v-bind="attrs"
            v-on="on"
            icon
            color="#FFB800"
        >
            <v-icon
            color="#FFB800"
            small
            class="premium-icon"
            >
                mdi-crown
            </v-icon>
        </v-btn>
      </template>

      <v-card class="premium-card">
        <v-card-text class="pa-4">
          <div class="d-flex align-center mb-2">
            <v-icon color="#FFB800" class="mr-2">mdi-crown</v-icon>
            <span class="font-weight-bold">Límite de versión gratuita</span>
          </div>
          <p class="mb-3 text-body-2">
            Actualiza a un plan de pago para desbloquear todas las funcionalidades
          </p>
          <v-btn
            color="#FFB800"
            class="white--text"
            block
            @click="$emit('upgrade')"
          >
            Prueba gratuita (6 días)
          </v-btn>
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'PremiumFeature',
  data: () => ({
    showMenu: false
  })
}
</script>

<style scoped>
.premium-icon {
  cursor: pointer;
  transition: transform 0.2s ease;
}

.premium-icon:hover {
  transform: scale(1.1);
}

.premium-card {
  border-radius: 8px;
}
</style> 